<!--
  Created 15.10.2023
  Simple Avatar component
  Displays an avatar image with a given size
-->
<template>
  <img
    class="inline-block rounded-full"
    :class="sizes[size]"
    :src="src"
    alt="avatar of a person">
</template>
<script setup>

defineProps({
  src: {
    type: String,
    required: true,
    default: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'].includes(value),
  },
});

const sizes = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-14 w-14',
  '2xl': 'h-16 w-16',
  '3xl': 'h-18 w-18',
  '4xl': 'h-20 w-20',
  '5xl': 'h-24 w-24',
  '6xl': 'h-28 w-28',
  '7xl': 'h-32 w-32',
};

</script>
